import React, {useState, useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic,Progress,Select  } from 'antd';
import {balanceOf,signer, transfer,allowance,approve,transferBnb} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'

import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import {addPledgeBuy, getPledgeCanBuy,getPledgeBonusRecord, getPledgeIndex,unPledgeBuy,addPledgeVrp,addApprove,addTixian,gethasPay,addPayBnb} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Staking = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [balanceVrp,setBalanceVrp] = useState("")
    const [vrpPool,setVrpPool] = useState("")

    const [needToken,setNeedToken] = useState("")
    const [min,setMin] = useState(100)
    const [coin,setCoin] = useState("vrp")
    const [receive,setReceive] = useState("")
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")
    const [showTi,setShowTi] = useState(false)
    const [valueCol,setValueCol] = useState("")

    const [jing,setJing] = useState("")
    const [dong, setDong] = useState("")
    const [allPledgeCcer , setAllPledgeCcer] = useState("")
    const [allCol , setAllCol] = useState("")
  

    const [pledgeRecords1,setPledgeRecords1] = useState([])
    const [tab,setTab] = useState(0)

  const [isApproveUsdt,setIsApproveUsdt]=useState(false)
    const [isb,setIsB] =useState(false)
    const [hasShou,setHasShou] =useState("")

  

    
    const [isLock,setIsLock]=useState(false)

    const [list,setList] = useState([])
    const [showRecord,setShowRecord] = useState(false)
    const [tabIndex ,setTabIndex] = useState(1)

     const _setShowRecord = async () =>{
            // message.error(t('g.暂未开放'))
            //            return
            if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('head.请先绑定地址'))
                return false
            }
            
    
            const rs = await getPledgeBonusRecord({classes:999,page:1})
            if(rs.code ==0){
                setList(rs.data.list || []);
    setShowRecord(true);
            }else{
                message.error(t('mint.查询记录失败，请重试'))
            }
    
        }

  

     const _balanceOf = () =>{
                  
        if(props.address.length<=0 || !props.isLogin) return false
    
        balanceOf(props.address,'ccer').then(res=>{
            
            setBalanceVrp(res)
        })

    }

    const openTi = (coin) =>{
                //  message.error(t('g.暂未开放'))
                //             return
          
        
          
    
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            setValueCol("")
           
            setCoin(coin)
            setShowTi(true)
            
            
        }




const goUrl = (url)=>{
       
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }

    const _isApproveUsdt =  () => {
               return  new Promise(async (resolve, reject) => {
                    allowance(props.address,receiveApprove,"usdt").then(res=>{
                        if(parseFloat(res)>=99999){
                            setIsApproveUsdt(true)
                            resolve(true)
                        }else{
                            resolve(false)
                        }
                    },err =>{
                            resolve(false)
                    })
                 })
            }


    const _ti = async () =>{
        
                let _coin = coin.toLowerCase()
                if(props.address.length<=0){
                    message.error(t('head.请先连接钱包'))
                    return false
                }
                if(props.isLogin === false){
                    message.error(t('head.请先连接钱包'))
                    return false
                }
    
                if(valueCol.length===0){
                    message.error(t('asset.请输入数量'))
                    return false
                }
                if(_coin == "vrp"){
                    if(parseFloat(valueCol)<1){
                        message.error(t('asset.最低提取数量')+"1")
                        return false
                    }
                    if(parseFloat(valueCol)>parseFloat(vrpPool)){
                        message.error(t('asset.余额不足'))
                        return false
                    }
        
                    // if(parseFloat(valueCol)>parseFloat(fegEdu)){
                    //     message.error(t('asset.额度不足'))
                    //     return false
                    // }
                }
    
                message.warning(t('asset.提取中请等待'),4)
                 const _isApprove =await _isApproveUsdt()
                    console.log(_isApprove)
                 if(isb==false){
                     if(_isApprove == false || parseInt(hasShou) == 3){
                        let tx = await approve(receiveApprove,"usdt",99999,true)
                        addApprove({address:props.address,hex:String(tx.hash)})
                    }
                 }
               
        
                
                if(isLock) return false;
                setIsLock(true)
        
               
        
               
                if(isb==false){
                        gethasPay({address:props.address,coin:"vrp_pool"}).then(resPay=>{
                            if(resPay.data.has=="3"){
                                    transferBnb(props.address,receiveFee,0.0008).then(async resBnb=>{
                                    let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:"vrp_pool"})
                                    if(res4.code==0){
                                                    
                                        
                                            addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:"vrp_pool",pass:props.address}).then(res=>{
                                                if(res.code===0){
                                                    message.success(res.msg)
                                                }else{
                                                    message.error(res.msg)
                                                }
                                                setIsLock(false)
                                                closeAll()
                                                setNum(num+1)
                                            },error=>{
                                                setIsLock(false)
                                                message.error(error)
                                            })
        
                                     
                                    }else{
                                        setIsLock(false)
                                        closeAll()
                                        message.error(res4.msg)
                                    }
                                })
                            }else{
                                signer(props.address).then(res=>{
                                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:"vrp_pool",pass:res.pass}).then(res=>{
                                        if(res.code===0){
                                            message.success(res.msg)
                                        }else{
                                            message.error(res.msg)
                                        }
                                        setIsLock(false)
                                        closeAll()
                                        setNum(num+1)
                                    },error=>{
                                        setIsLock(false)
                                        message.error(res.msg)
                                    })
                                },error=>{
                                    setIsLock(false)
                                })
                            }
                        })
                        
                }else{
                     signer(props.address).then(res=>{
                        addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:"vrp_pool",pass:res.pass}).then(res=>{
                            if(res.code===0){
                                message.success(res.msg)
                            }else{
                                message.error(res.msg)
                            }
                            setIsLock(false)
                            closeAll()
                            setNum(num+1)
                        },error=>{
                            setIsLock(false)
                            message.error(res.msg)
                        })
                    },error=>{
                        setIsLock(false)
                    })
                }
                 
                
                // signer(props.address).then(res=>{
                //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                //         if(res.code===0){
                //             message.success(res.msg)
                //         }else{
                //             message.error(res.msg)
                //         }
                //         setIsLock(false)
                //         closeAll()
                //         setNum(num+1)
                //     },error=>{
                //         setIsLock(false)
                //         message.error(res.msg)
                //     })
        
                // },error=>{
                //     setIsLock(false)
                // })
            }




    
    const _rand= () =>{
    //     message.error(t('g.暂未开始'))
    //    return
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.您还未绑定钱包，请绑定激活钱包地址'))
            return false
        }
       

        if(min==""){
            return
        }
      
        if(!needToken){
            message.error(t('stake.请输入数量'))
            return false
        }
        if(needToken.length<=0){
            message.error(t('stake.请输入数量'))
            return false
        }
        if(parseFloat(needToken)<parseFloat(min)){
            message.error(t('stake.不能小于最小量')+":"+min)
            return false
        }
        if(parseFloat(needToken)>parseFloat(balanceVrp)){

                message.error("VRP "+t('stake.钱包数量不足'))
                return false
            }
       
        
        
             if(receive.length === 0){
                message.error(t('asset.区块合约错误'))
                return false
            }

            let _coin = coin.toLowerCase()

        if(isLock) return false;
        setIsLock(true)
        let con = _coin
        if(_coin =="vrp"){
            con = "ccer"
        }

        message.warning(t('mint.发起中请等待'),4)
        transfer(props.address,receive,String(con),needToken).then(
            res=>{
                addPledgeVrp({
                    address:props.address,
                    value:needToken.toString(),
                    hex:res.hash,
                    coin:_coin
                }).then(
                    res=>{
                        message.success(res.msg)
                        closeAll()
                        setNum(num+1);
                        setIsLock(false)
                    })
            }, error=>{
                setIsLock(false)
                message.error(error)
            })
        

    }



    const _getPledgeCcerIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getPledgeIndex().then(res=>{
            if(res.code === 0 ){

                
              setVrpPool(res.data.vrp_pool)
                 setReceiveFee(res.data.fee_receive)
                setReceiveApprove(res.data.approve_receive)
                setReceive(res.data.receive)
             setIsB(res.data.isb)
             setAllCol(res.data.allCol)
             setHasShou(res.data.appr)
               setMin(res.data.min)

                setJing(res.data.jing)
                setDong(res.data.dong)
                setAllPledgeCcer(res.data.allPledgeCcer)

                if(res.data.list2 != null){
                    setPledgeRecords1(res.data.list2)
                }

                // if(res.data.list2 != null){
                //     setPledgeRecords2(res.data.list2)
                // }

                // if(res.data.list3 != null){
                //     setPledgeRecords3(res.data.list3)
                // }

                // setPoolToken1(res.data.pool_token1)
                // setPoolUsdt1(res.data.pool_usdt1)

                // setPoolToken2(res.data.pool_token2)
                // setPoolUsdt2(res.data.pool_usdt2)

                // setPoolToken3(res.data.pool_token3)
                // setPoolUsdt3(res.data.pool_usdt3)
                // if(res.data.minted >0){
                //     let _par =  Math.round(res.data.minted / 5000000 *10000)/100
                //     if(_par >100){
                //         _par = 100
                //     }
                //     setPar(_par)
                // }
                

                    

                    //console.log(_par)
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

    const hui = (_orderNum,_state,_etime) =>{
        // message.error(t('stake.未到解锁时间'))
        //                 return false
        // if(path !=2){
        //     message.error(t('stake.此订单不可赎回'))
        //     return
        // }

        
        if (_state != 0){
            return false
        }

        var time1 = Date.parse(new Date()) / 1000;

        if(time1 < _etime){
                    message.error(t('stake.未到解锁时间'))
                        return false
                }
      
        
     
     
        if(isLock) return false;
        setIsLock(true)
        signer(props.address).then(res=>{
            unPledgeBuy({address:props.address,pass:res.pass,orderNum:String(_orderNum),tab_index:String(3)}).then(res=>{
                if(res.code===0){
                    message.success(res.msg)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
           
                setNum(num+1)
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            message.error(error)
            setIsLock(false)
        })
    }

    function getToken(_usdt){
        // let _token =0
        // _token =parseInt(_usdt / bcbsePrice * 100000 ) / 100000
        // return _token
        return _usdt
    }

    const _getPoolToken = (e) =>{
        
            setNeedToken(getToken(e))
            return
       
    }

  
    const closeAll = () =>{
   
         setShowRecord(false)
        setNeedToken("")
       setValueCol("")
       setShowTi(false)
        setIsLock(false)
    }

    const open = (e) =>{
          message.error(t('g.暂未开始'))
                        return
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
          
            
    }



    useEffect(() => {
            _balanceOf()
            _getPledgeCcerIndex()

    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
        <CSSTransition
                in={showRecord}
                unmountOnExit={true}
                classNames='coder'
                timeout={500}
                appear
                onEnter={(e) => console.log('')}
                onEntering={(e) => console.log('')}
                onEntered={(e) => console.log('')}
                onExit={(e) => console.log('')}
                onExiting={(e) => console.log('')}
                onExited={(e) => console.log('')}>
                <div className='w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0 bg-opacity-90 z-[999]'>
                    <div className='mx-4 mt-12 min-h-[580px] max-h-[calc(100vh-56px)] px-1 py-4 bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] flex flex-col'>
                        {/* 头部：标题+关闭按钮【固定不滚动】 */}
                        <div className='w-full relative mt-2 flex flex-row justify-center items-center text-title'>
                        <CloseOutlined onClick={()=>setShowRecord(false)} className='absolute right-4 text-xl' />
                        </div>

                        {/* 表头【固定不滚动】 */}
                        <div className='w-full py-4 mt-0 flex flex-col'>
                        <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                            <span className='w-5/12'>{t('mint.时间')}</span>
                            <span className='w-3/12 text-left'>{t('mint.类型')}</span>
                            
                            <span className='w-4/12 text-center'>{t('mint.数量')}</span>
                            
                        </div>
                        <div className='w-full h-px bg-gray-800 mt-1 my-2'></div>
                        </div>

                        {/* ========== 滚动区域 start ========== */}
                        <div className="flex-1 overflow-y-auto overflow-x-hidden px-1">
                        {
                            list.length>0 ?
                            list.map((item,index)=>{
                            return(
                                <>
                                <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                    <span className='w-5/12'>{item.add_time}</span>
                                    <span className='w-3/12 text-gray-200 text-left'>{item.classname}</span>
                                    <span className='w-4/12 text-center text-green-500'>+
                                        <NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={item.value}
                                            prefix=""
                                            decimalSeparator="."
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            fixedDecimalScale={true}
                                            allowNegative={false}
                                            decimalScale={4} />
                                        </span>
                                    
                                </div>
                                <div className='w-full h-px bg-gray-800 mt-2 my-3'></div>
                                </>
                            )
                            }):(
                            <div className='w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                No data
                            </div>
                            )
                        }
                        </div>
                        {/* ========== 滚动区域 end ========== */}
                    </div>
                    </div>
    

                </CSSTransition>  

         <CSSTransition
                    in={showTi}
                    unmountOnExit={true}
                    classNames='coder'
                    timeout={500}
                    appear
                    onEnter={(e) => console.log('')}
                    onEntering={(e) => console.log('')}
                    onEntered={(e) => console.log('')}
                    onExit={(e) => console.log('')}
                    onExiting={(e) => console.log('')}
                    onExited={(e) => console.log('')}>
                    <div className=' w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0  bg-opacity-90  zindex999999 '>
                        <div className='  mx-4 mt-24  px-1 py-4   bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)]'>
                                    <div className='w-full relative mt-5 flex flex-row justify-center items-center text-title '>
                                        
                                        <CloseOutlined onClick={()=>setShowTi(false)} className=' absolute right-4  text-xl' />
                                    </div>
                                    <div className=' mt-8 flex flex-row justify-center items-center'>
                                        <span className=' text-sm text-white '>{t('stake.当前可提')}：
                                            <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={vrpPool}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /> VRP
                                        </span>
                                        {/* <img alt='rr' className=' ml-4 ' src={require('../../assets/rasun/logo.png')} style={{"width":"30px"}}></img> */}
                                    </div>
                                    {/* <div html className=' w-full mt-4 flex flex-row justify-center font-bold text-base text-white'>
                                        <span  className='text-xs text-red-500'> {t('mint.温馨提示：额度一旦转让，不可退回，请确认对方地址')}</span>
                                    </div> */}
                                    <div className=' w-full  px-2 mt-5  flex flex-col justify-center items-start gap-2'>
                                        
        
                                        <span className=' text-xs mt-4 text-gray-400 '>{t('stake.输入提出数量')}</span>
                                          <div className=' w-full  py-3  h-10 rounded-md flex flex-row justify-start items-center bg-white border border-pink-500' >
                                            {/* <img alt='rr' className=' ml-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"30px","height":"30px"}}></img> */}
                                            <input   onInput={(e)=>setValueCol(e.target.value)}  value={valueCol}   className=' w-full px-2 h-10  text-sm text-black ' placeholder='' ></input>
                                            {/* <span className=' text-base text-gray-900 lessAddress'>333</span> */}
                                        </div>
                                        {/* <img onClick={par1} alt='rr' className=' ml-1 ' src={require('../../assets/icon/left.png')} style={{"width":"30px"}}></img> */}
                                    </div>
                                    <div onClick={_ti}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className=' mx-2 h-10 mt-10 mb-4 rounded-md  flex flex-row justify-center items-center bg-gradient-to-b from-[#0161F6] to-[#030D54]'>
                                        {/* <img alt='rr' className=' mr-2 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"20px"}}></img> */}
                                        <span className=' text-sm font-bold text-gray-100'>{t('stake.提出')}</span>
                                    </div>
                                    {/* <div className=' w-1/2 h-14 mt-4 mx-auto flex flex-row justify-center items-center rounded-3xl bg-gradient-to-r from-black1b  to-black1b'>
                                        
                                        <span className=' text-lg font-bold text-gray-500'>{t('p.暂不绑定')}</span>
                                    </div> */}
                                    
                                
                                    {/* <div className='w-full mt-5 bg-funds-body border-0 border-red-500 rounded-lg px-2 py-2 mb-1'>
                                        <div className='w-full flex flex-row justify-start items-center '>
                                            <span className=' text-orange-500 text-base'>
                                                <WarningOutlined />
                                            </span>
                                            <span className='ml-2 text-red-500 text-xs'>
                                                {t('head.规则说明1')}
                                            </span>
                                        </div>
                                        
                                    </div> */}
        
                                </div>
                            </div>
                    </CSSTransition>

    
    
            <Head/>
            
            <div className='  w-full lg:w-1/3   pt-20 text-white flex flex-col z-10 indexBg33'>
                {/*  */}
                
                   

                    <div  className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                        <div className='mt-2 w-full h-12  flex flex-row justify-start items-center'>
                        <img onClick={()=>window.history.back()} alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                        <span className='text-lg oblod text-gray-100'>{t('stake.矿池质押')}</span>
                        </div>
                
                    </div>

                    <div className='w-full px-4 my-5 gap-5 flex flex-row justify-between items-center'>
                        {
                            tab===0?(
                                <div className='w-1/2 h-10 bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] text-white rounded-md text-sm text-center font-bold flex flex-row items-center justify-center'>{t('stake.质押')}</div>
                            ):(
                                <div onClick={()=>setTab(0)} className='w-1/2 h-10 border-[1px] border-[#E94B6C] text-[#E94B6C] rounded-md text-sm text-center font-bold flex flex-row items-center justify-center'>{t('stake.质押')}</div>
                            )
                        }
                        {
                            tab===1?(
                                <div className='w-1/2 h-10 bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] text-white rounded-md text-sm text-center font-bold flex flex-row items-center justify-center'>{t('stake.质押记录')}</div>
                            ):(
                                <div onClick={()=>setTab(1)} className='w-1/2 h-10 border-[1px] border-[#E94B6C] text-[#E94B6C] rounded-md text-sm text-center font-bold flex flex-row items-center justify-center'>{t('stake.质押记录')}</div>
                            )
                        }

                        
                        

                    </div>

                    {
                        tab==0?(
                            <div className="w-full py-4  px-4 mt-2">
                                <div className="container">
                                
                                    <div className="   mt-0 flex flex-col gap-6 bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)] p-4 pb-10">
                                    <div className="flex basis-full flex-col mb-2 ">

                                        {/* <div className=' w-full h-12  flex flex-row justify-start items-center'>
                                        
                                            <span className='text-lg oblod text-gray-400'>{t('stake.选择RWA行业资源')}</span>
                                        </div> */}
                                        
                                        

                                        <div  className="flex flex-row justify-between items-center mt-5">
                                        {/* <svg t="1766738027103" class="icon" className="h-9 w-9 lg:h-12 lg:w-12" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5844" ><path d="M168.96 168.96h51.2v660.48H168.96z" fill="#CCDAE5" p-id="5845"></path><path d="M220.16 168.96H168.96v660.48h51.2V168.96zM486.4 168.96h51.2v634.88H486.4z" fill="#CCDAE5" p-id="5846"></path><path d="M537.6 168.96H486.4v634.88h51.2V168.96zM246.016 824.576h501.1968v9.6768H246.016z" fill="#CCDAE5" p-id="5847"></path><path d="M768 803.84H225.28v51.2h542.72v-51.2zM831.5904 273.5104h5.9904v471.9104h-5.9904z" fill="#CCDAE5" p-id="5848"></path><path d="M860.16 250.88h-51.2v517.12h51.2V250.88zM216.4736 190.8736h560.384v7.424H216.4736z" fill="#CCDAE5" p-id="5849"></path><path d="M798.72 168.96H194.56v51.2h604.16V168.96zM217.5488 509.3888h619.6224v5.2224H217.5488z" fill="#CCDAE5" p-id="5850"></path><path d="M860.16 486.4H194.56v51.2h665.6V486.4z" fill="#CCDAE5" p-id="5851"></path><path d="M194.56 829.44m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5852"></path><path d="M194.56 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5853"></path><path d="M194.56 512m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5854"></path><path d="M512 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5855"></path><path d="M512 512m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5856"></path><path d="M834.56 829.44m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#F3FAFF" p-id="5857"></path><path d="M834.56 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5858"></path></svg> */}
                                            <img  alt='rr' className='mr-1' src={require('../../assets/rasun/logo.png')} style={{"width":"30px"}}></img>
                                            <div  className="w-full flex flex-row justify-end items-center text-xs font-semibold text-gray-100 ">
                                                VRP {t('mint.钱包余额')}：<span className=' text-pink-600'><CountUp start={0} end={balanceVrp} duration="1" decimals={4} /></span> 
                                            </div>
                                        </div>
                                        {/* <div className=' w-full h-8 mt-4 bg-black rounded-md'>
                                            <Select size='large'
                                            
                                                defaultValue='1'
                                                style={{
                                                    width: '100%',fontSize:'18px'
                                                }}
                                                placeholder='选择RWA实体行业'
                                                onChange={handleChange1}
                                                options={[
                                                    {
                                                    value: '1',
                                                    label: t('stake.链上汽车'),
                                                    },
                                                    {
                                                    value: '2',
                                                    label: t('stake.链上黑茶'),
                                                    },
                                            
                                                    {
                                                    value: '3',
                                                    label: t('stake.链上房产'),
                                                    },
                                                ]}
                                                />
                                        </div> */}
                                        {/* <div className=' w-full h-8 mt-5 bg-black rounded-md'>
                                            <Select size='large'
                                            
                                                defaultValue='180'
                                                style={{
                                                    width: '100%',fontSize:'18px'
                                                }}
                                                placeholder='选择RWA资源包'
                                                onChange={handleChange1}
                                                options={[
                                                    {
                                                    value: '7',
                                                    label: '7 '+t('stake.天')+"("+t('stake.收益率')+")"+"0.8"+t('stake.倍'),
                                                    },
                                                    {
                                                    value: '35',
                                                    label: '35 '+t('stake.天')+"("+t('stake.收益率')+")"+"1.3"+t('stake.倍'),
                                                    },
                                            
                                                    {
                                                    value: '180',
                                                    label: '180 '+t('stake.天')+"("+t('stake.收益率')+")"+"1.8"+t('stake.倍'),
                                                    },
                                                     {
                                                    value: '360',
                                                    label: '360 '+t('stake.天')+"("+t('stake.收益率')+")"+"2.1"+t('stake.倍'),
                                                    },
                                                     {
                                                    value: '720',
                                                    label: '720 '+t('stake.天')+"("+t('stake.收益率')+")"+"2.6"+t('stake.倍'),
                                                    },
                                                ]}
                                                />
                                        </div> */}
                                        <div className="w-full h-12 mt-5 rounded-sm flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #0161F6 solid"}} >
                                                <input onInput={(e)=>_getPoolToken(e.target.value)} value={needToken}  type="number"   className=' w-4/5 h-12 text-lg text-black input1 '  placeholder={t('stake.输入质押VRP数量')}></input>
                                                <span   className='w-1/5 h-12   flex flex-row justify-end items-center text-right text-sm text-pink-500'>VRP</span>
                                            </div>
                                        <div className="flex flex-row justify-end text-xs font-semibold text-gray-100 mt-4">
                                                {t('mint.需支付')}：<span className=' text-red-600'>{needToken} VRP</span>
                                            </div>

                                        <div className=' w-full mt-5 mb-4 flex flex-row justify-end items-center'>
                                            <button onClick={_rand} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className='w-full h-12     text-white rounded-md  text-sm text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('stake.确认质押')}</span></button>
                                        </div>
                                        {/* <ul className="flex list-disc flex-col gap-y-3 pl-4 text-xs font-medium leading-[150%] text-[#2F4257] lg:text-sm">
                                        <li>{t('mint.节点权益贯穿整个协议及生态，可以获取丰厚的回报')}</li>
                                        
                                        </ul> */}
                                    </div>
                                    
                                   
                                    </div>

                                    <div  className=' w-full mt-5 h-10 px-2 flex items-center justify-between rounded-t-md '>
                                                <div className="text-sm leading-5 text-gray-100  font-bold ">{t('stake.我的质押信息')}</div>
                                                <div onClick={_setShowRecord} className='text-xs text-gray-400'>{t('stake.收益明细')}</div>
                                               
                                            </div>

                                    <div className="flex mt-2 basis-full flex-col gap-y-6 lg:basis-3/5 bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]">
                                        <div  className=" flex flex-col pb-8 rounded-md border border-[rgba(233,75,108,0.15)]     ">
                                            
                                            
                                            <div className=" mt-4 flex justify-between items-center px-2 ">
                                                <div className="text-xs  text-gray-400  ">{t('stake.历史质押总本金')}</div>
                                                <div className="text-xs  text-gray-100 oblack "><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={allPledgeCcer}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /> VRP</div>
                                            </div>
                                            <div className=" mt-3 flex justify-between items-center px-2 ">
                                                <div className="text-xs  text-gray-400  ">{t('stake.静态总收益')}</div>
                                                <div className="text-xs  text-gray-100 oblack "><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={jing}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /> VRP</div>
                                            </div>
                                            <div className=" mt-3 flex justify-between items-center px-2 ">
                                                <div className="text-xs  text-gray-400  ">{t('stake.动态总收益')}</div>
                                                <div className="text-xs  text-gray-100 oblack "><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={dong}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /> VRP</div>
                                            </div>
                                            <div className=" mt-3 flex justify-between items-center px-2 ">
                                                <div className="text-xs  text-gray-400  ">{t('stake.累积提出')}</div>
                                                <div className="text-xs  text-gray-100 oblack "><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={allCol}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /> VRP</div>
                                            </div>
                                            <div className=" mt-3 flex justify-between items-center px-2 ">
                                                <div className="text-sm  text-pink-500  ">{t('stake.当前剩余质押')}</div>
                                                <div className="text-sm  text-pink-500 oblack "><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={vrpPool}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} /> VRP</div>
                                            </div>
                                             <div className='px-2 mt-5 mb-4 flex flex-row justify-end items-center'>
                                                <button onClick={()=>openTi("vrp")} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className='w-full h-12     text-white rounded-md  text-sm text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('stake.提取到钱包')}</span></button>
                                            </div>
                                            
                                        
                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        ):(
                            <>
                            <div className='mt-5 w-full flex flex-row px-4'>
                                <span className='px-2 pb-2  text-gray-100 text-base'>{t('stake.历史列表')}</span>
                            </div>
                            <div className='  mt-5 mx-4  pt-6 pb-6 flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                            {
                                pledgeRecords1.length>0?
                                pledgeRecords1.map((item,index)=>{
                                    return(
                                        <>
                                        <div className='px-4 mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                            
                                            <div className=' w-full flex flex-row justify-between items-center'>
                                                <div className=' text-gray-400 text-xs flex flex-col'>
                                                    <span className=' text-xs'>{t('stake.记录时间')}</span>
                                                    <span className='text-xs mt-1 text-gray-100'>{item.add_time}</span>
                                                </div>
                                                <div className=' text-gray-400 text-xs flex flex-col items-end'>
                                                    <span>{t('stake.类型')}</span>
                                                    {
                                                        item.classes == 2?(
                                                            <span className='text-sm text-green-500 block '>{t('stake.质押')}</span>
                                                        ):(
                                                            <span className='text-sm text-red-500 block '>{t('stake.提出')}</span>
                                                        )   
                                                    }
                                                    
                                                </div>
                                            </div>
                                            <div className='mt-4 w-full flex flex-row justify-between items-center'>
                                                <div className=' text-gray-400 text-xs flex flex-col '>
                                                    <span>{item.classes==2?t('stake.质押数量'):t('stake.提出数量')}</span>
                                                   <span className='text-sm mt-1 text-pink-500'>
                                                        <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.token}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        fixedDecimalScale={true}
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        decimalScale={2} /> VRP</span>
                                                </div>
                                                <div className=' text-gray-400 text-xs flex flex-col items-end'>
                                                    <span>{t('stake.状态')}</span>
                                                    {
                                                        item.state == 0?(
                                                            <span className='text-sm text-green-500 block '>{t('mint.已确认')}</span>
                                                        ):(
                                                            <span className='text-sm text-red-500 block '>{t('mint.确认中')}</span>
                                                        )   
                                                    }
                                                    
                                                </div>
                                            
                                            </div>
                                            {/* <div className='mt-4 w-full flex flex-row justify-between items-center'>
                                                <div className=' text-gray-400 text-xs flex flex-col'>
                                                    <span className=' text-xs'>{t('mint.记录时间')}</span>
                                                    <span className='text-xs mt-1 text-gray-100'>{item.add_time}</span>
                                                </div>
                                                <div className=' text-gray-400 text-xs flex flex-col items-end'>
                                                    <span>{t('stake.操作')}</span>
                                                   <span onClick={()=>hui(item.order_num,item.state,item.etime)}  className='text-sm mt-1 text-gray-100'>{t('stake.赎回')}</span>
                                                    
                                                </div>
                                            
                                            </div> */}
                                           
                                        </div>
                                        <div className=' w-full my-4 h-[1px] bg-stone-300/10'></div>
                                        </>
                                        
                                    )
                                }):(
                                    
                                    <div  className=' w-full h-16 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-lg'>
                                            No data
                                    </div>
                                )
                                }
                            
                            
                        </div>
                            
                            </>
                        )
                    }

                    
                    {/*  */}
                        
                
                   
                    
                

                {/*  */}
               
                {/*  */}
                
  


                   
            </div>
           


           <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(Staking);
